/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_Check1Inputs */

const en_funnel_pw_check1 = /** @type {(inputs: Funnel_Pw_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited listening: papers, PDFs, websites, books`)
};

const es_funnel_pw_check1 = /** @type {(inputs: Funnel_Pw_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha sin límites: artículos, PDF, webs y libros`)
};

/**
* | output |
* | --- |
* | "Unlimited listening: papers, PDFs, websites, books" |
*
* @param {Funnel_Pw_Check1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_check1 = /** @type {((inputs?: Funnel_Pw_Check1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_Check1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_check1(inputs)
	return en_funnel_pw_check1(inputs)
});